import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Input } from '../components/ui/Input';

export const StagingPasswordPage: React.FC = () => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const stagingAccess = sessionStorage.getItem('stagingAccess');
    if (stagingAccess === 'granted') {
      navigate('/');
    }
  }, [navigate]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    setTimeout(() => {
      if (password === 'Casey08') {
        sessionStorage.setItem('stagingAccess', 'granted');
        navigate('/');
      } else {
        setError('Incorrect password. Please try again.');
        setPassword('');
      }
      setIsLoading(false);
    }, 500);
  };

  return (
    <>
      {/* Header */}
      <header style={{
        background: 'rgba(255, 255, 255, 0.95)',
        position: 'sticky',
        top: '0',
        zIndex: 'var(--z-50)'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 2rem'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            height: '4.5rem',
            paddingTop: 'var(--space-6)',
            paddingBottom: 'var(--space-6)'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: 'var(--space-8)'
            }}>
              <Link to="/" style={{
                display: 'flex',
                alignItems: 'center',
                gap: 'var(--space-3)',
                textDecoration: 'none'
              }}>
                <div style={{
                  width: '2rem',
                  height: '2rem',
                  position: 'relative',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '8px',
                  background: '#c8102e',
                  boxShadow: '0 2px 8px rgba(200, 16, 46, 0.3), 0 1px 3px rgba(200, 16, 46, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.2)',
                  overflow: 'hidden'
                }}>
                  <div style={{
                    position: 'absolute',
                    inset: '0'
                  }}>
                    <div style={{
                      position: 'absolute',
                      top: '2px',
                      right: '2px',
                      width: '8px',
                      height: '8px',
                      background: 'linear-gradient(45deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.08))',
                      borderRadius: '2px',
                      opacity: '0.7'
                    }}></div>
                    <div style={{
                      position: 'absolute',
                      bottom: '4px',
                      left: '4px',
                      width: '6px',
                      height: '6px',
                      background: 'linear-gradient(45deg, rgba(255, 255, 255, 0.12), rgba(255, 255, 255, 0.06))',
                      borderRadius: '1px',
                      opacity: '0.5'
                    }}></div>
                    <div style={{
                      position: 'absolute',
                      top: '6px',
                      left: '6px',
                      width: '4px',
                      height: '4px',
                      background: 'linear-gradient(45deg, rgba(255, 255, 255, 0.18), rgba(255, 255, 255, 0.10))',
                      borderRadius: '1px',
                      opacity: '0.4'
                    }}></div>
                  </div>
                  <div style={{
                    position: 'relative',
                    color: 'white',
                    fontSize: '14px',
                    fontWeight: '400',
                    textShadow: '0 0 8px rgba(255, 255, 255, 0.4)',
                    zIndex: '2'
                  }}>✦</div>
                </div>
                <span style={{
                  fontSize: 'var(--font-size-xl)',
                  fontWeight: 'var(--font-weight-bold)',
                  color: 'var(--neutral-900)',
                  letterSpacing: '-0.025em'
                }}>
                  Odyssey
                </span>
              </Link>
            </div>
            
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: 'var(--space-3)'
            }}>
              <button style={{
                padding: 'var(--space-2) var(--space-4)',
                color: 'var(--neutral-400)',
                background: 'transparent',
                border: 'none',
                borderRadius: 'var(--radius-md)',
                fontWeight: 'var(--font-weight-medium)',
                fontSize: 'var(--font-size-sm)',
                cursor: 'not-allowed',
                opacity: '0.5'
              }} disabled>
                Login
              </button>
              <button style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 'var(--space-2)',
                padding: 'var(--space-2) var(--space-4)',
                background: 'var(--neutral-300)',
                color: 'var(--neutral-500)',
                border: 'none',
                borderRadius: 'var(--radius-md)',
                fontWeight: 'var(--font-weight-semibold)',
                fontSize: 'var(--font-size-sm)',
                cursor: 'not-allowed',
                opacity: '0.5'
              }} disabled>
                Sign Up
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          marginTop: '-4.5rem',
          paddingTop: '4.5rem',
          padding: '2rem',
          backgroundColor: 'white',
          boxSizing: 'border-box'
        }}>
          <div style={{
            width: '100%',
            maxWidth: '400px',
            textAlign: 'center'
          }}>
            <h2 style={{
              marginBottom: '0.5rem',
              fontSize: '1.75rem',
              fontWeight: '600',
              color: 'var(--neutral-900)'
            }}>
              Access Staging Environment
            </h2>
            <p style={{
              marginBottom: '2rem',
              color: 'var(--neutral-700)',
              fontSize: '1rem'
            }}>
              Please enter the password to access the staging site.
            </p>
            
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: '1rem' }}>
                <Input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter password"
                  error={error}
                  disabled={isLoading}
                  autoFocus
                  fullWidth
                />
              </div>
              
              <button 
                type="submit" 
                disabled={isLoading || !password.trim()}
                style={{
                  width: '100%',
                  padding: 'var(--space-3) var(--space-4)',
                  background: '#1a1a1a',
                  color: 'white',
                  border: 'none',
                  borderRadius: 'var(--radius-lg)',
                  fontWeight: 'var(--font-weight-medium)',
                  fontSize: 'var(--font-size-base)',
                  cursor: isLoading || !password.trim() ? 'not-allowed' : 'pointer',
                  opacity: isLoading || !password.trim() ? '0.5' : '1',
                  fontFamily: 'var(--font-family)',
                  transition: 'all var(--duration-150) var(--ease-out)'
                }}
              >
                {isLoading ? 'Verifying...' : 'Access Site'}
              </button>
            </form>
          </div>
        </div>
    </>
  );
};